module.exports = __webpack_public_path__ + "h5/img/ljqd.bdf31ce0.png";